
import InputSelect from "@/components/Inputs/InputSelect/InputSelect.vue";
import { validations } from "@/core/helpers/formatosInputs";
import Multiselect from "@vueform/multiselect";
import { computed, defineComponent, reactive } from "vue";
import InputCustom from "../Inputs/InputCustom/InputCustom.vue";
import { validacaoBootstrap } from "@/core/helpers/validacaoBootstrap";

export default defineComponent({
  name: "custom-search",
  components: {
    Multiselect,
    InputCustom,
    InputSelect,
  },
  props: {
    fields: {
      type: Array,
      required: true,
      default: () => [],
    },
    title: {
      type: String,
      required: true,
    },
  },
  setup() {
    let data = reactive({
      researched: false,
      more_options: true,
    });
    const validacoes = computed(() => {
      return validations;
    });
    return {
      data,
      validacoes,
    };
  },
  data: () => {
    return {
      result: [] as any,
    };
  },
  watch: {
    fields: {
      handler(newFields, oldFields) {
        newFields.forEach((field, index) => {
          const oldField = oldFields?.[index];
          if (field.disabled) {
            this.result[index].value = null;
          }
        });
      },
      deep: true,
    },
  },
  methods: {
    onSubmit(event) {
      this.data.researched = true;
      let values = JSON.parse(JSON.stringify(this.result));
      const form = event.target as HTMLFormElement;
      if (!validacaoBootstrap(form)) {
        return;
      }
      for (let i = 0; i < values.length; i++) {
        if (!values[i].value) {
          values[i].value = "";
        }
      }

      this.$emit("aplicar", values);
    },
    closeDropDown() {
      this.$emit("close", "");
    },
    clearAndClose() {
      this.cleanAllInput();
      this.$emit("cleaned", { cleaned: true });
    },
    closeDropDownAndCancel() {
      this.closeDropDown();
      if (this.data.researched) {
        this.data.researched = false;
        this.$emit("canceled", { canceled: true });
      }
    },
    onChangeSection(event, name) {
      this.result.find((item) => item.name === name).value = event.target.value;
      this.$emit("selected", { name, value: event.target.value });
    },
    onChangeSectionMultiselect(value, name) {
      this.result.find((item) => item.name === name).value = value;
      this.$emit("selected", { name, value });
    },
    onChangeSectionInputSelect(event, name) {
      let value = "";
      if (event && typeof event === "object") {
        if (event.target && event.target.value !== undefined) {
          value = event.target.value;
        } else if (event.value !== undefined) {
          value = event.value;
        } else {
          value = event;
        }
      } else {
        value = event;
      }
      this.result.find((item) => item.name === name).value = value;
      this.$emit("selected", { name, value });
    },
    getData() {
      this.fields.forEach((item) => {
        let value = "";
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if ("value" in item) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          value = item.value ? item.value : "";
        }

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.result.push({ name: item.name, value: value });
      });
    },
    cleanAllInput() {
      for (let i = 0; i < this.result.length; i++) {
        this.result[i].value = "";
      }
    },
    showField(field) {
      if ("show" in field) {
        if (field.show === false) {
          return false;
        }
      }
      return true;
    },
    showMoreOptions() {
      this.data.more_options = !this.data.more_options;
    },
    showFieldByIndex(index) {
      if (index < 4) return true;
      if (!this.data.more_options) return true;
      return false;
    },
  },
  created() {
    this.getData();
  },
});
